import type { FieldStaff } from '../types';

export const persistentSessionKey = 'hr-ready-h5-promotion-session';
export const temporarySessionKey = 'hr-ready-h5-promotion-temporary-session';

export function storeFieldProfile(staff: FieldStaff, remember: boolean): void {
  clearStoredFieldProfile();
  const storage = remember ? window.localStorage : window.sessionStorage;
  const key = remember ? persistentSessionKey : temporarySessionKey;
  storage.setItem(key, JSON.stringify({ staff }));
}

export function readStoredFieldProfile(): FieldStaff | null {
  for (const [storage, key] of [
    [window.sessionStorage, temporarySessionKey],
    [window.localStorage, persistentSessionKey],
  ] as const) {
    try {
      const value = JSON.parse(storage.getItem(key) || 'null');
      if (value?.staff?.id) return value.staff;
    } catch {
      storage.removeItem(key);
    }
  }
  return null;
}

export function clearStoredFieldProfile(): void {
  window.localStorage.removeItem(persistentSessionKey);
  window.sessionStorage.removeItem(temporarySessionKey);
}

export function clearStoredFieldSession(): void {
  clearStoredFieldProfile();
}
